<script lang="ts">
export const description  = 'A sidebar that collapses to icons.'
export const iframeHeight = '800px'
export const containerClass = 'w-full h-full'
</script>

<script setup lang="ts">
import { onMounted, onUnmounted, ref, nextTick } from 'vue'
import { Project, colsproject } from './timintables/colsproject'
import { User   , colsuser } from './timintables/colsuser'
import { Booking, colsbooking } from './timintables/colsbooking'
import { Config , colsconfig } from './timintables/colsconfig'
import Planner    from './timinplanner/D3Planner.vue'
import DataTable from './timintables/DataTable.vue'

import AppSidebar from '@/components/AppSidebar.vue'
import { Separator } from '@/components/ui/separator'
import {
  SidebarInset,
  SidebarProvider,
} from '@/components/ui/sidebar'
import { useViewStore } from '@/stores/viewStore'
import { useUserStore } from '@/stores/userStore';

const dataprojects = ref<Project[]>([])
const databookings = ref<Booking[]>([])
const datausers    = ref<User[]>([])
const dataconfigs  = ref<Config[]>([])
const dataroles    = ref([])
const isLoading = ref(true)
	
async function getDataUrl(url) {
  try {
    const response = await fetch(url);
    const data = await response.json();
    console.log('Received data!', data);
    return data;
  } catch (error) {
    console.error('Error fetching data!', error);
    return null;
  }
}

async function getData(category): Promise<Project[]> {
  // Fetch data from your API here.
  return getDataUrl('/' + category + '.json');
}


const updatePlanner = ref(0);

async function reload() {
	console.log("reload")
	dataprojects.value = await getData('projects')
	datausers.value    = await getData('users')
	databookings.value = await getData('bookings')
	dataconfigs.value  = await getData('configs')
	dataroles.value    = await getData('roles')
	colsproject.filter(c => c.key === "id")[0].options = dataprojects.value.map(p => ({id: p.id, label: p.name}));
	colsbooking.filter(c => c.key === "user_id")[0].options = datausers.value.map(u => ({id: u.id, label: u.name}));
	colsbooking.filter(c => c.key === "project_id")[0].options = dataprojects.value.map(p => ({id: p.id, label: p.name}));
	colsuser.filter(c => c.key === "role_id")[0].options = dataroles.value.map(r => ({id: r.id, label: r.name}));
	isLoading.value = false
	updatePlanner.value++
}
onMounted(() => reload());

const viewStore = useViewStore();
const userStore = useUserStore();

function isPlanner() {
  return viewStore.actionView === 'planner'
}

function handleClickOutside(e: MouseEvent) {
  const popup = document.querySelector('.callout') as HTMLElement
  if (popup && !popup.contains(e.target as Node)) {
    emit('close')
  }
}

</script>

<template>
  <SidebarProvider>
    <AppSidebar :projects="dataprojects" :actionView="actionView" @updateView="actionView = $event"/>
    <SidebarInset class="w-screen h-screen">	  
      <div style="height: 100%">
		<div id="planner-container" style="margin-left: unset; height: 100%" :class="['container',{'planner-container': isPlanner()}]">
		  <Planner v-if="viewStore.actionView === 'planner'   && !isLoading"  :key="updatePlanner"  :projects="dataprojects" :bookings="databookings" :users="datausers.filter(u => u.is_active === 1)" :configs="dataconfigs"  @update:bookings="databookings = $event" @update:projects="dataprojects = $event" @reload="reload" />
		  <DataTable v-if="viewStore.actionView === 'projects'  && !isLoading" :key="updatePlanner"  :enableediting="true" label="Projekte"      endpoint="projects" :columns="colsproject"  @update="reload" />
	    <DataTable v-if="viewStore.actionView === 'bookings'  && !isLoading" :key="updatePlanner"  :enableediting="true" label="Buchungen"     endpoint="bookings" :columns="colsbooking"  @update="reload" />
      <DataTable v-if="viewStore.actionView === 'resources' && !isLoading" :key="updatePlanner"  :enableediting="true" label="Resourcen"     endpoint="users"    :columns="colsuser"     @update="reload"/>
      <DataTable v-if="viewStore.actionView === 'settings'  && !isLoading" :key="updatePlanner"  :enableediting="true" label="Einstellungen" endpoint="configs"  :columns="colsconfig"   @update="reload"/>
		</div>
      </div>
    </SidebarInset>
  </SidebarProvider>
</template>

<style>
.bg-black\/80 {
  background-color: transparent !important;
}
</style>

